<ng-container [formGroup]="formGroup">
  <mat-form-field appearance="outline">
    <mat-label i18n>User Field</mat-label>
    <mat-select id="user-field" formControlName="userField">
      <mat-option *ngFor="let option of discreteUserFieldNamesWithCategoryNames" [value]="option.id">
        {{ option.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>{{ getUserFieldName() }}</mat-label>
    <mat-select id="user-field-category" multiple formControlName="userFieldCategories">
      <mat-option *ngFor="let option of getUserFieldCategories()" [value]="option.id" [title]="option.name">
        {{ option.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-container>
